import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateSupportTeam,
    deleteSupportTeam,
    getListSupportTeams,
    getPageSupportTeams,
} from '../SupportTeamEndPoint'

export const useListSupportTeams = (
    hospitalId,
    requestorId,
    simple = false,
    filterRequest = {},
    enabled = true,
) => {
    const {supportTeamKeys} = QueryKeyManager(
        QueryKeyTypes.supportTeam,
        requestorId,
    )
    return useQuery({
        queryKey: supportTeamKeys.list({hospitalId, simple, filterRequest}),
        queryFn: () => getListSupportTeams(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const usePageSupportTeams = (
    hospitalId,
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {supportTeamKeys} = QueryKeyManager(
        QueryKeyTypes.supportTeam,
        requestorId,
    )

    return useQuery({
        queryKey: supportTeamKeys.page({
            hospitalId,
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageSupportTeams(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                !!hospitalId ? {...filterRequest, hospitalId} : filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useSupportTeamCRUD = (type, requestorId) => {
    const {supportTeamKeys} = QueryKeyManager(
        QueryKeyTypes.supportTeam,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateSupportTeam(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteSupportTeam(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Support Team Update Successfully !!',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}
